<template>
  <a-layout :class="`container-protal env-${env}`">
    <!-- 左侧菜单 -->
    <a-layout-sider
      collapsible
      :class="{
        collapsed: collapsed
      }"
      :width="256"
      :trigger="null"
      v-if="isRouterAlive"
    >
      <div
        :class="[
          'logo',
          env === 'production' ? '' : 'noProduction',
          collapsed ? 'collapsed' : ''
        ]"
      >
        <img
          src="~assets/img/logo2.png"
          width="40"
          height="40"
          alt=""
          v-if="env === 'production' || collapsed"
        />
        <h2
          v-show="!collapsed"
          class="title cp"
          @click="() => router.push('/')"
        >
          {{ env !== 'production' ? '南京云次方' : 'CUPSHE' }}

          <a-dropdown v-if="env !== 'production'" class="env">
            <a class="ant-dropdown-link" @click.prevent>
              {{
                options.find(option => {
                  return option.value == selectValue
                })['label']
              }}
              <DownOutlined />
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item
                  v-for="option in options"
                  :key="option.label"
                  @click="handleChange(option.value)"
                >
                  {{ option.label }}
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </h2>
      </div>
      <sidebar :collapsed="collapsed" @updateFrame="openFrame" />
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="layout">
        <div
          style="height:40px;line-height:40px;width: 40px;cursor: pointer;"
          @click="changeMenuFold"
        >
          <menu-unfold-outlined
            v-if="collapsed"
            class="trigger fs16"
            style="margin: 0 16px;"
          />
          <menu-fold-outlined
            v-else
            class="trigger fs16"
            style="margin: 0 16px;"
          />
        </div>

        <navbar :collapsed="collapsed"> </navbar>
      </a-layout-header>
      <!-- 内容 -->
      <a-layout-content :class="isFrame ? 'b-fff' : 'b-eff2f5'">
        <section class="con" :class="isFrame ? '' : ' ch'">
          <router-view v-if="isRouterAlive"></router-view>
        </section>
      </a-layout-content>
    </a-layout>

    <a-popover placement="left" size="small" v-model:visible="showPopup">
      <template #content>
        <ul>
          <li class="fs12 df aic cp" @click="changeMenuFold">
            <menu-unfold-outlined
              v-if="collapsed"
              style="font-size:16px;color:#1890ff"
            />
            <menu-fold-outlined
              v-else
              class="trigger"
              style="font-size:16px;"
            />
            <span
              class="ml10"
              :class="{
                'c-active': collapsed
              }"
              >{{ collapsed ? '展开菜单' : '收起菜单' }}</span
            >
          </li>
          <li class="fs12 df aic mt10 cp" @click="fullScreen">
            <FullscreenOutlined
              v-if="!isFullScreen"
              class="fs16"
              @click="fullScreen"
            />
            <FullscreenExitOutlined style="color:#1890ff" class="fs16" v-else />
            <span
              class="ml10"
              :class="{
                'c-active': isFullScreen
              }"
            >
              {{ isFullScreen ? '取消全屏' : '全屏模式' }}</span
            >
          </li>
        </ul>
      </template>
      <span
        class="fixed-menu "
        :class="{
          ball: collapsed
        }"
        v-if="showBottomMenu"
        style="width: 44px; height: 44px; line-height: 44px; font-size: 22px;"
      >
        <menu-unfold-outlined
          v-if="collapsed"
          class="trigger"
          style="font-size:18px;color:#fff"
        />
        <menu-fold-outlined
          v-else
          class="trigger"
          style="font-size:18px;color:#fff"
        />
        <CloseOutlined
          @click.stop="closeBottomMenu"
          style="font-size:14px;position:absolute;top:-10px;"
        ></CloseOutlined>
      </span>
    </a-popover>
  </a-layout>
</template>
<script>
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import { useRouter, useRoute } from 'vue-router'
import {
  ref,
  computed,
  reactive,
  provide,
  toRefs,
  watch,
  onMounted,
  nextTick
} from 'vue'
import { useStore } from 'vuex'
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DownOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  CloseOutlined
} from '@ant-design/icons-vue'
export default {
  components: {
    Navbar,
    CloseOutlined,
    Sidebar,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    DownOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined
  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const collapsed = ref(false)
    const isFrame = ref(false)
    const store = useStore()
    const asiderWidth = computed(() => (collapsed.value ? '80px' : '256px'))
    const searchValue = ref(null)
    // process.env
    const state = reactive({
      isFullScreen: false,
      showPopup: false,
      showBottomMenu: true,
      env: process.env.VUE_APP_ENV,
      isRouterAlive: true,
      router,
      selectValue:
        location.origin.indexOf(`${window.location.protocol}//portal`) > -1
          ? location.origin
          : `${window.location.protocol}//portal-develop.kapeixi.cn`,
      fullScreen() {
        state.showPopup = false
        let docElm = document.documentElement
        if (!state.isFullScreen) {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.msRequestFullscreen) {
            docElm.msRequestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen()
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen()
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          }
        }
        const el = document.querySelector('.fixed-menu')
        el.style.right = '20px'
        el.style.top = 'unset'
        el.style.left = 'unset'
        el.style.bottom = '80px'
      }
    })
    const options = [
      {
        value: `${window.location.protocol}//portal-develop.kapeixi.cn`,
        label: '开发'
      },
      {
        value: `${window.location.protocol}//portal-release.kapeixi.cn`,
        label: '测试'
      },
      {
        value: `${window.location.protocol}//portal-pre.kapeixi.cn`,
        label: '预上线'
      },
      {
        value: `${window.location.protocol}//portal-npro.kapeixi.cn`,
        label: 'npro环境'
      }
    ]

    const handleChange = value => {
      window.open(value)
    }
    const closeBottomMenu = () => {
      state.showBottomMenu = false
    }
    watch(
      () => route.fullPath,
      () => {
        const target = route.query.target
        isFrame.value = target ? true : false
      },
      {
        immediate: true
      }
    )
    const changeMenuFold = e => {
      if (e.type === 'click') {
        collapsed.value = !collapsed.value
        localStorage.setItem('menu_collapsed', collapsed.value ? 1 : 0)
      }
    }

    onMounted(() => {
      // const menu_collapsed = localStorage.getItem('menu_collapsed')
      // if (menu_collapsed) {
      //   collapsed.value = +menu_collapsed === 1
      // }
      document.addEventListener('fullscreenchange', () => {
        nextTick(() => {
          console.log('fullscreenchange')
          state.isFullScreen = !state.isFullScreen
        })
      })

      const el = document.querySelector('.fixed-menu')
      let clientX = 0,
        clientY = 0
      // 在元素上做些操作
      el.onmousedown = function(e) {
        state.showPopup = false
        e.preventDefault()
        e.stopPropagation()
        const nodeName = e.currentTarget.nodeName
        let disx = e.clientX - el.offsetLeft
        let disy = e.clientY - el.offsetTop
        // 鼠标按下时
        document.onmousemove = function(e) {
          state.showPopup = false
          let x = e.clientX - disx
          let y = e.clientY - disy
          if (x >= window.innerWidth - el.offsetWidth) {
            x = window.innerWidth - el.offsetWidth
          }
          if (x > 0 && y > 20 && y <= window.innerHeight - 44) {
            el.style.left = x + 'px'
            el.style.top = y + 'px'
          }
        }
        document.onmouseup = function() {
          document.onmousemove = document.onmouseup = null
        }
        return false
      }

      if (window.matchMedia('(max-width: 799px)')?.matches) {
        collapsed.value = true
      }
    })

    /**
     * 全路劲： 使用iframe打开第三方系统
     * 否则： 跳转到当前页面
     */
    const openFrame = menuItem => {
      if (!menuItem) {
        router.push({
          path: '/home'
        })
        return false
      }
      const path = menuItem.menuPath
      menuItem['systemId'] = localStorage.getItem('otherSystemId')
      searchValue.value = menuItem.menuName
      store.commit(
        'user/saveHistoryRouter',
        {
          data: menuItem,
          isMenu: true
        },
        {
          root: true
        }
      )
      if (path.trim().startsWith('http')) {
        router.push({
          name: 'Iframe',
          query: {
            target: path
          }
        })
      } else {
        router.push({
          path
        })
      }
    }
    provide('openFrame', openFrame)
    provide('searchValue', searchValue)
    provide('parentState', state)
    return {
      ...toRefs(state),
      isFrame,
      openFrame,
      closeBottomMenu,
      collapsed,
      route,
      options,
      asiderWidth,
      handleChange,
      changeMenuFold
    }
  }
}
</script>
<style lang="scss" scoped>
.fixed-menu {
  position: fixed;
  bottom: 20%;
  right: 10px;
  cursor: pointer;
  color: #000;
  background-color: #fff;
  box-shadow: 0 4px 12px #00000026;
  transition: color 0.3s;
  border-radius: 50%;
  text-align: center;
  z-index: 99;

  &.ball {
    animation: bounce 2s 3 ease-in-out alternate;
    opacity: 0.5;

    &:hover {
      opacity: 1;
      /* animation: unset !important; */
      cursor: pointer;
    }
  }
}
@-webkit-keyframes bounce {
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes bounce {
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}
.container-protal {
  height: 100%;
}
.pd24 {
  padding: 16px 0;
}
.ch {
  height: calc(100% - 35px);
}
aside {
  overflow: auto;
  height: 100vh;
  position: relative;
  top: 0;
  left: 0;
  margin-bottom: 48px;
}
.c-active {
  color: rgba(30, 160, 240, 1);
}
/* aside::-webkit-scrollbar {
  width: 6px;
} */

.layout {
  background: #fff;
  padding: 0;
  height: 50px;
  line-height: 50px;
  display: flex;
  align-items: center;
  :deep .layout-header {
    padding: 0 16px;
    flex: 1;
  }
}
main {
  margin: 10px;
  text-align: left;
}

.b-eff2f5 {
  background: #eff2f5;
}

.ant-layout-content {
  flex: 1;
  min-height: unset;
  overflow: auto;
}
.logo {
  margin: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  &.collapsed {
    margin: 0 20px;
  }
  h2.title {
    color: #fff;
    margin-bottom: 0;
    padding-left: 8px;
  }
  &.noProduction {
    padding: 0;
    h2 {
      display: flex;
      align-items: center;
      font-size: 18px;
    }
  }
}
.mt15 {
  margin-top: 15px;
}
</style>
<style lang="scss">
.ant-layout-sider {
  transition: all 0.2s;
  /* display: none !important; */
}
.ant-layout-sider.collapsed {
  width: 0px !important;
  min-width: 0px !important;
  max-width: 0px !important;
}
.ant-layout-sider-collapsed {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
.env-develop .ant-layout-sider,
.env-develop .wrapper,
.env-develop .ant-layout-sider-trigger,
.env-develop .fixed-menu {
  background: #8494a5 !important;
}

.env-develop .ant-menu.ant-menu-dark,
.env-develop .ant-menu-dark .ant-menu-sub,
.env-develop .ant-menu.ant-menu-dark .ant-menu-sub {
  background: #758493 !important;
}

.env-develop
  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
  .ant-menu-item-selected {
  background: #a9b9c9 !important;
}

.env-test .ant-layout-sider,
.env-test .wrapper,
.env-test .ant-layout-sider-trigger,
.env-test .fixed-menu {
  background: #003685 !important;
}

.env-test .ant-menu.ant-menu-dark,
.env-test .ant-menu-dark .ant-menu-sub,
.env-test .ant-menu.ant-menu-dark .ant-menu-sub {
  background: #002c6b !important;
}

.env-test
  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
  .ant-menu-item-selected {
  background: #3d7dd8 !important;
}

.env-pre .ant-layout-sider,
.env-pre .wrapper,
.env-pre .ant-layout-sider-trigger {
  background: #098be3 !important;
}

.env-pre .ant-menu.ant-menu-dark,
.env-pre .ant-menu-dark .ant-menu-sub,
.env-pre .ant-menu.ant-menu-dark .ant-menu-sub,
.env-pre .fixed-menu {
  background: #0376c4 !important;
}

.env-pre
  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
  .ant-menu-item-selected {
  background: #0061a7 !important;
}
.env-production .fixed-menu {
  background: #001529;
}
.env.ant-select {
  display: inline-block;
  width: 80px !important;
  text-align: center;
  .ant-select-selector {
    background-color: transparent !important;
    border: none !important;
    color: #fff;
    padding: 0 !important;
    height: 100% !important;
  }
  .ant-select-arrow {
    color: #fff;
  }
  &.ant-select-single.ant-select-open .ant-select-selection-item {
    color: #fff !important;
  }
}
.env.ant-dropdown-link {
  display: inline-block;
  width: 80px !important;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>
